<template>
  <v-text-field
    :ref="name"
    v-validate="validation"
    :data-vv-name="name"
    :data-vv-scope="scope"
    :data-vv-as="label"
    :error-messages="errorMessages"
    :label="label|capitalize"
    :name="name"
    :required="required"
    :value="computedValue"
    :counter="counter"
    :messages="inputMessages"
    :placeholder="placeholder"
    :class="{
      'nx-form-text': true,
      'counter-recommended': hasRecommendedTextLimit,
    }"
    data-vv-value-path="value"
    data-vv-validate-on="input|blur"
    :disabled="disabled"
    v-bind="$attrs"
    :spellcheck="spellcheck"
    @blur="onBlur($event)"
    @focus="onFocus()"
    @input="onInput($event)"
  >
    <template slot="prepend">
      <v-btn
        v-if="$attrs.prependIcon && $attrs.prependIconLink"
        class="mt-0 mx-0 mb-1"
        icon
        small
        :to="generateRouterLink($attrs.prependIconLink)"
      >
        <v-icon
          color="primary"
          v-text="$attrs.prependIcon"
        />
      </v-btn>
      <slot
        v-else
        name="prepend"
      />
    </template>
    <template slot="append">
      <v-btn
        v-if="$attrs.appendIcon && $attrs.appendIconLink"
        class="mt-0 mx-0 mb-1"
        icon
        small
        :to="generateRouterLink($attrs.appendIconLink)"
      >
        <v-icon
          color="primary"
          v-text="$attrs.appendIcon"
        />
      </v-btn>
      <slot
        v-else
        name="append"
      />
      <v-btn
        v-if="assistantComponent"
        class="mt-0 mx-0 mb-1"
        icon
        small
        @click.prevent="$emit('bcube-assistant', { inputName: name, component: assistantComponent })"
      >
        <v-icon
          color="primary"
          v-text="'tips_and_updates'"
        />
      </v-btn>
    </template>
    <template slot="append-outer">
      <slot name="append-outer" />
    </template>
  </v-text-field>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import CanGenerateRouterLinks from '@/modules/form/mixins/can-generate-router-links';
import isObject from 'lodash/isObject';
import { uncapitalize } from '@/filters';

export default {
  name: 'NxFormText',
  mixins: [FormElement, CanGenerateRouterLinks],
  props: {
    value: {
      type: [String, Number],
    },
    spellcheck: {
      type: Boolean,
    },
    counter: {
      type: [Number, Boolean],
    },
    placeholder: {
      type: String,
      default: null,
    },
    translatedValue: {
      type: Boolean,
    },
    translatedValuePrefix: {
      type: String,
      default: null,
    },
    translatedValueSuffix: {
      type: String,
      default: null,
    },
  },
  computed: {
    assistantComponent() {
      return this.$attrs.bcubeAssistantComponent || this.$attrs['bcube-assistant-component'];
    },
    computedValue() {
      if (!this.translatedValue) {
        return this.value;
      }

      const translation = [
        this.translatedValuePrefix,
        uncapitalize(this.value),
        this.translatedValueSuffix,
      ].filter(Boolean).join('.');

      return this.$te(translation) ? this.$t(translation) : this.value;
    },
    inputMessages() {
      if (!this.$parentForm || !this.$parentForm.draft) {
        return [];
      }

      let history = this.$parentForm.draft.bcubeAssistantHistory;
      if (!history || history.length === 0) {
        history = {};
      }

      if (!history[this.name]) {
        return [];
      }

      return [this.$t('message.bcubeAssistant.generatedFromAI')];
    },
    hasRecommendedTextLimit() {
      if (!this.counter) {
        return true;
      }
      if (!this.validation) {
        return true;
      }
      if (!isObject(this.validation)) {
        return this.validation.includes('max') === false;
      }
      return !this.validation.max;
    },
  },
};
</script>

<style lang="stylus">
@import '../../../assets/stylus/variables.styl'

// Counter has recommended color
.nx-form-text.counter-recommended .v-counter.error--text {
  color: $warning !important;
}
</style>
